import {
  Component,
  EventEmitter,
  Inject,
  Input,
  OnInit,
  Output,
} from '@angular/core';
import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';
import { GeneralService } from 'src/app/services/general/general.service';
import {
  FormGroup,
  FormBuilder,
  Validators,
  FormArray,
  FormControl,
} from '@angular/forms';
import { Router } from '@angular/router';


@Component({
  selector: 'app-hours-pack-dialog',
  templateUrl: './hours-pack-dialog.component.html',
  styleUrls: ['./hours-pack-dialog.component.scss'],
})
export class HoursPackDialogComponent implements OnInit {
  public form: FormGroup;
  priceHour: any;
  threeDiscount: number;
  fiveDiscount: number;
  sevenDiscount: number; 
  isBtnDisabled: boolean = true;

  public user: any;
  public userInfo: any;
  response_cupon :any;
  public teacher_info: any;
  public teacher_id:number;
  public lesson_id:any;

  constructor(
    public dialogRef: MatDialogRef<HoursPackDialogComponent>,
    @Inject(MAT_DIALOG_DATA) public data: any,
    public general: GeneralService,
    private formBuilder: FormBuilder,
    private router: Router

  ) {

    this.form = this.formBuilder.group({
      hours: [1, [Validators.required]],
      paymentMethod: ['', [Validators.required]],
      couponText: [''],
      conditions: ['', [Validators.required]],
    });
    this.teacher_id = data.teacher_id;
    this.teacher_info = data.teacher_info;
    this.priceHour = data.priceHour;
    this.lesson_id = data.lesson_id
    this.threeDiscount = (this.priceHour - this.priceHour * 0.03) * 5;
    this.fiveDiscount = (this.priceHour - this.priceHour * 0.05) * 10;
    this.sevenDiscount = (this.priceHour  - this.priceHour * 0.07) * 15;
  }

  async ngOnInit() {
    try {
      await this.getUserInfo();
    } catch (error) {
    }
  }
  
  async getUserInfo() {
    const response = await this.general.getUserInfo();
    this.userInfo = response.data;
    this.user = this.userInfo.user;
  }

  closeDialog(response: Boolean) {
    this.dialogRef.close(response);
  }

  async sendForm() {

    const data = {
      hours: parseInt(this.form.value.hours),
      paymentMethod: this.form.value.paymentMethod,
      coupon_text: this.form.value.couponText,
      conditions: this.form.value.conditions,
      lesson_id: this.lesson_id
      
    };   
    
    this.dialogRef.close(data);
  }
 

  // Consumir cupón
  async checkCoupon() {
       
    this.general.setLoading(true);  
    try {
            const response = await this.general.httpPost(
              'coupon-check',
              {
                coupon_text: this.form.value.couponText,
                user_id: this.user.id,
                teacher_id: this.teacher_id,
                lesson_id: this.lesson_id
              }
            ); 
          
            if (response.success==true) {
              this.response_cupon = response.data;      
            } 
          
            if (response.data.coupon.discount_type==0) {  
              this.priceHour = response.data.coupon_data.price_hour_single;
              this.threeDiscount = response.data.coupon_data.price_five_hours;
              this.fiveDiscount = response.data.coupon_data.price_ten_hours;
              this.sevenDiscount = response.data.coupon_data.price_fifteen_hours;
                
            }
          
            if (response.data.coupon.discount_type==1) {
                this.priceHour = response.data.coupon_data.price_hour_single;
                this.threeDiscount = response.data.coupon_data.price_five_hours;
                this.fiveDiscount = response.data.coupon_data.price_ten_hours;
                this.sevenDiscount = response.data.coupon_data.price_fifteen_hours;         
            }

              
            if (response.data.coupon.discount_type==2) {
                await this.general.showSuccess('Se ha procesado correctamente tu cupón.');
                setTimeout(function(){
                  console.log("waited for: 3 seconds");
                  location.reload();
                }, 5000);  
            }
        } catch(error) {
          await this.general.showDanger('El cupón introducido no es válido.');
          
          this.form.controls.couponText.patchValue('');
        }



     
      // console.log('response: ',this.response_cupon); 
  }

}